import { Injectable } from '@angular/core';
import { Country } from 'ecomm-shared';

// VAT Code: OUTPUT2 for UK & EU (20%), EU 0% ECZROUTPUTSERVICES and no vat NONE

@Injectable({
    providedIn: 'root'
})
export class StaticDataService {
    static ZERO_RATED_INCOME(ZERO_RATED_INCOME: any) {
        throw new Error("Method not implemented.");
    }
    static UK_VAT(UK_VAT: any) {
        throw new Error("Method not implemented.");
    }

    static readonly UNITED_STATES = 'US';
    static readonly UNITED_KINGDOM = 'GB';
    static readonly AUSTRALIA = 'AU';
    static readonly IRELAND = 'IE';
    static readonly BRAZIL = 'BR';
    static readonly CHINA = 'CN';
    static readonly CANADA = 'CA';
    static readonly ITALY = 'IT';
    static readonly INDIA = 'IN';
    static readonly MEXICO = 'MX';
    static readonly licenseNameAndCompanyNameRegex = /^[\w\s\.,\/?:;@#~\-+!()&]*$/;
    static readonly addressRegex = /^((?!\u202F|\u00A0).)*[a-zA-Z0-9\s\.,\/?:;@#~\-+!()&]]*$/;
    static readonly phoneNumberValidation = /^[0-9+\- ]*$/
    static readonly cityRegex = /^[ a-zA-Z-']*$/;
    static readonly resellerEmailDomains = ['liquidpc.com'];

    static readonly US_STATES = [
        { name: 'Alaska', abbreviation: 'AK' },
        { name: 'Alabama', abbreviation: 'AL' },
        { name: 'Arkansas', abbreviation: 'AR' },
        { name: 'Arizona', abbreviation: 'AZ' },
        { name: 'California', abbreviation: 'CA' },
        { name: 'Colorado', abbreviation: 'CO' },
        { name: 'Connecticut', abbreviation: 'CT' },
        { name: 'District of Columbia', abbreviation: 'DC' },
        { name: 'Delaware', abbreviation: 'DE' },
        { name: 'Florida', abbreviation: 'FL' },
        { name: 'Georgia', abbreviation: 'GA' },
        { name: 'Hawaii', abbreviation: 'HI' },
        { name: 'Iowa', abbreviation: 'IA' },
        { name: 'Idaho', abbreviation: 'ID' },
        { name: 'Illinois', abbreviation: 'IL' },
        { name: 'Indiana', abbreviation: 'IN' },
        { name: 'Kansas', abbreviation: 'KS' },
        { name: 'Kentucky', abbreviation: 'KY' },
        { name: 'Louisiana', abbreviation: 'LA' },
        { name: 'Massachusetts', abbreviation: 'MA' },
        { name: 'Maryland', abbreviation: 'MD' },
        { name: 'Maine', abbreviation: 'ME' },
        { name: 'Michigan', abbreviation: 'MI' },
        { name: 'Minnesota', abbreviation: 'MN' },
        { name: 'Missouri', abbreviation: 'MO' },
        { name: 'Mississippi', abbreviation: 'MS' },
        { name: 'Montana', abbreviation: 'MT' },
        { name: 'North Carolina', abbreviation: 'NC' },
        { name: 'North Dakota', abbreviation: 'ND' },
        { name: 'Nebraska', abbreviation: 'NE' },
        { name: 'New Hampshire', abbreviation: 'NH' },
        { name: 'New Jersey', abbreviation: 'NJ' },
        { name: 'New Mexico', abbreviation: 'NM' },
        { name: 'Nevada', abbreviation: 'NV' },
        { name: 'New York', abbreviation: 'NY' },
        { name: 'Ohio', abbreviation: 'OH' },
        { name: 'Oklahoma', abbreviation: 'OK' },
        { name: 'Oregon', abbreviation: 'OR' },
        { name: 'Pennsylvania', abbreviation: 'PA' },
        { name: 'Puerto Rico', abbreviation: 'PR' },
        { name: 'Rhode Island', abbreviation: 'RI' },
        { name: 'South Carolina', abbreviation: 'SC' },
        { name: 'South Dakota', abbreviation: 'SD' },
        { name: 'Tennessee', abbreviation: 'TN' },
        { name: 'Texas', abbreviation: 'TX' },
        { name: 'Utah', abbreviation: 'UT' },
        { name: 'Virginia', abbreviation: 'VA' },
        { name: 'Vermont', abbreviation: 'VT' },
        { name: 'Washington', abbreviation: 'WA' },
        { name: 'Wisconsin', abbreviation: 'WI' },
        { name: 'West Virginia', abbreviation: 'WV' },
        { name: 'Wyoming', abbreviation: 'WY' }
    ];

    static readonly UK_COUNTIES = [
        { name: 'Bedfordshire' },
        { name: 'Buckinghamshire' },
        { name: 'Cambridgeshire' },
        { name: 'Cheshire' },
        { name: 'Cleveland' },
        { name: 'Cornwall' },
        { name: 'Cumbria' },
        { name: 'Derbyshire' },
        { name: 'Devon' },
        { name: 'Dorset' },
        { name: 'Durham' },
        { name: 'East Sussex' },
        { name: 'Essex' },
        { name: 'Gloucestershire' },
        { name: 'Greater London' },
        { name: 'Greater Manchester' },
        { name: 'Hampshire' },
        { name: 'Hertfordshire' },
        { name: 'Kent' },
        { name: 'Lancashire' },
        { name: 'Leicestershire' },
        { name: 'Lincolnshire' },
        { name: 'Merseyside' },
        { name: 'Norfolk' },
        { name: 'North Yorkshire' },
        { name: 'Northamptonshire' },
        { name: 'Northumberland' },
        { name: 'Nottinghamshire' },
        { name: 'Oxfordshire' },
        { name: 'Shropshire' },
        { name: 'Somerset' },
        { name: 'South Yorkshire' },
        { name: 'Staffordshire' },
        { name: 'Suffolk' },
        { name: 'Surrey' },
        { name: 'Tyne and Wear' },
        { name: 'Warwickshire' },
        { name: 'West Berkshire' },
        { name: 'West Midlands' },
        { name: 'West Sussex' },
        { name: 'West Yorkshire' },
        { name: 'Wiltshire' },
        { name: 'Worcestershire' },
        { name: 'Flintshire' },
        { name: 'Glamorgan' },
        { name: 'Merionethshire' },
        { name: 'Monmouthshire' },
        { name: 'Montgomeryshire' },
        { name: 'Pembrokeshire' },
        { name: 'Radnorshire' },
        { name: 'Anglesey' },
        { name: 'Breconshire' },
        { name: 'Caernarvonshire' },
        { name: 'Cardiganshire' },
        { name: 'Carmarthenshire' },
        { name: 'Denbighshire' },
        { name: 'Aberdeen City' },
        { name: 'Aberdeenshire' },
        { name: 'Angus' },
        { name: 'Argyll and Bute' },
        { name: 'City of Edinburgh' },
        { name: 'Clackmannanshire' },
        { name: 'Dumfries and Galloway' },
        { name: 'Dundee City' },
        { name: 'East Ayrshire' },
        { name: 'East Dunbartonshire' },
        { name: 'East Lothian' },
        { name: 'East Renfrewshire' },
        { name: 'Eilean Siar' },
        { name: 'Falkirk' },
        { name: 'Fife' },
        { name: 'Glasgow City' },
        { name: 'Highland' },
        { name: 'Inverclyde' },
        { name: 'Midlothian' },
        { name: 'Moray' },
        { name: 'North Ayrshire' },
        { name: 'North Lanarkshire' },
        { name: 'Orkney Islands' },
        { name: 'Perth and Kinross' },
        { name: 'Renfrewshire' },
        { name: 'Scottish Borders' },
        { name: 'Shetland Islands' },
        { name: 'South Ayrshire' },
        { name: 'South Lanarkshire' },
        { name: 'Stirling' },
        { name: 'West Dunbartonshire' },
        { name: 'West Lothian' },
        { name: 'Antrim' },
        { name: 'Armagh' },
        { name: 'Down' },
        { name: 'Fermanagh' },
        { name: 'Derry and Londonderry' },
        { name: 'Tyrone' }
    ];

    static readonly AU_STATES = [
        { name: 'Australian Capital Territory', abbreviation: 'ACT' },
        { name: 'New South Wales', abbreviation: 'NSW' },
        { name: 'Northern Territory', abbreviation: 'NT' },
        { name: 'Queensland', abbreviation: 'QLD' },
        { name: 'South Australia', abbreviation: 'SA' },
        { name: 'Tasmania', abbreviation: 'TAS' },
        { name: 'Victoria', abbreviation: 'VIC' },
        { name: 'Western Australia', abbreviation: 'WA' },
    ];

    static readonly BR_STATES = [
        { name: 'Acre', abbreviation: 'AC' },
        { name: 'Alagoas', abbreviation: 'AL' },
        { name: 'Amazonas', abbreviation: 'AM' },
        { name: 'Amapá', abbreviation: 'AP' },
        { name: 'Bahia', abbreviation: 'BA' },
        { name: 'Ceará', abbreviation: 'CE' },
        { name: 'Distrito Federal', abbreviation: 'DF' },
        { name: 'Espírito Santo', abbreviation: 'ES' },
        { name: 'Goiás', abbreviation: 'GO' },
        { name: 'Maranhão', abbreviation: 'MA' },
        { name: 'Minas Gerais', abbreviation: 'MG' },
        { name: 'Mato Grosso do Sul', abbreviation: 'MS' },
        { name: 'Mato Grosso', abbreviation: 'MT' },
        { name: 'Pará', abbreviation: 'PA' },
        { name: 'Paraíba', abbreviation: 'PB' },
        { name: 'Pernambuco', abbreviation: 'PE' },
        { name: 'Piauí', abbreviation: 'PI' },
        { name: 'Paraná', abbreviation: 'PR' },
        { name: 'Rio de Janeiro', abbreviation: 'RJ' },
        { name: 'Rio Grande do Norte', abbreviation: 'RN' },
        { name: 'Rondônia', abbreviation: 'RO' },
        { name: 'Roraima', abbreviation: 'RR' },
        { name: 'Rio Grande do Sul', abbreviation: 'RS' },
        { name: 'Santa Catarina', abbreviation: 'SC' },
        { name: 'Sergipe', abbreviation: 'SE' },
        { name: 'São Paulo', abbreviation: 'SP' },
        { name: 'Tocantins', abbreviation: 'TO' },
    ];

    static readonly CA_STATES = [
        { name: 'Alberta', abbreviation: 'AB' },
        { name: 'British Columbia', abbreviation: 'BC' },
        { name: 'Manitoba', abbreviation: 'MB' },
        { name: 'New Brunswick', abbreviation: 'NB' },
        { name: 'Newfoundland and Labrador', abbreviation: 'NL' },
        { name: 'Nova Scotia', abbreviation: 'NS' },
        { name: 'Northwest Territories', abbreviation: 'NT' },
        { name: 'Nunavut', abbreviation: 'NU' },
        { name: 'Ontario', abbreviation: 'ON' },
        { name: 'Prince Edward Island', abbreviation: 'PE' },
        { name: 'Quebec', abbreviation: 'QC' },
        { name: 'Saskatchewan', abbreviation: 'SK' },
        { name: 'Yukon Territories', abbreviation: 'YT' },
    ];

    static readonly CN_STATES = [
        { name: 'Beijing', abbreviation: '11' },
        { name: 'Tianjin', abbreviation: '12' },
        { name: 'Hebei', abbreviation: '13' },
        { name: 'Shanxi', abbreviation: '14' },
        { name: 'Nei Mongol', abbreviation: '15' },
        { name: 'Liaoning', abbreviation: '21' },
        { name: 'Jilin', abbreviation: '22' },
        { name: 'Heilongjiang', abbreviation: '23' },
        { name: 'Shanghai', abbreviation: '31' },
        { name: 'Jiangsu', abbreviation: '32' },
        { name: 'Zhejiang', abbreviation: '33' },
        { name: 'Anhui', abbreviation: '34' },
        { name: 'Fujian', abbreviation: '35' },
        { name: 'Jiangxi', abbreviation: '36' },
        { name: 'Shandong', abbreviation: '37' },
        { name: 'Henan', abbreviation: '41' },
        { name: 'Hubei', abbreviation: '42' },
        { name: 'Hunan', abbreviation: '43' },
        { name: 'Guangdong', abbreviation: '44' },
        { name: 'Guangxi', abbreviation: '45' },
        { name: 'Hainan', abbreviation: '46' },
        { name: 'Chongqing', abbreviation: '50' },
        { name: 'Sichuan', abbreviation: '51' },
        { name: 'Guizhou', abbreviation: '52' },
        { name: 'Yunnan', abbreviation: '53' },
        { name: 'Xizang', abbreviation: '54' },
        { name: 'Shaanxi', abbreviation: '61' },
        { name: 'Gansu', abbreviation: '62' },
        { name: 'Qinghai', abbreviation: '63' },
        { name: 'Ningxia', abbreviation: '64' },
        { name: 'Xinjiang', abbreviation: '65' },
        { name: 'Taiwan', abbreviation: '71' },
        { name: 'Hong Kong', abbreviation: '91' },
        { name: 'Macao', abbreviation: '92' },
    ];

    static readonly IE_STATES = [
        { name: 'Clare', abbreviation: 'CE' },
        { name: 'Cavan', abbreviation: 'CN' },
        { name: 'Cork', abbreviation: 'CO' },
        { name: 'Carlow', abbreviation: 'CW' },
        { name: 'Dublin', abbreviation: 'D' },
        { name: 'Donegal', abbreviation: 'DL' },
        { name: 'Galway', abbreviation: 'G' },
        { name: 'Kildare', abbreviation: 'KE' },
        { name: 'Kilkenny', abbreviation: 'KK' },
        { name: 'Kerry', abbreviation: 'KY' },
        { name: 'Longford', abbreviation: 'LD' },
        { name: 'Louth', abbreviation: 'LH' },
        { name: 'Limerick', abbreviation: 'LK' },
        { name: 'Leitrim', abbreviation: 'LM' },
        { name: 'Laois', abbreviation: 'LS' },
        { name: 'Meath', abbreviation: 'MH' },
        { name: 'Monaghan', abbreviation: 'MN' },
        { name: 'Mayo', abbreviation: 'MO' },
        { name: 'Offaly', abbreviation: 'OY' },
        { name: 'Roscommon', abbreviation: 'RN' },
        { name: 'Sligo', abbreviation: 'SO' },
        { name: 'Tipperary', abbreviation: 'TA' },
        { name: 'Waterford', abbreviation: 'WD' },
        { name: 'Westmeath', abbreviation: 'WH' },
        { name: 'Wicklow', abbreviation: 'WW' },
        { name: 'Wexford', abbreviation: 'WX' },
    ];

    static readonly IN_STATES = [
        { name: 'Andaman and Nicobar Islands', abbreviation: 'AN' },
        { name: 'Andhra Pradesh', abbreviation: 'AP' },
        { name: 'Arunachal Pradesh', abbreviation: 'AR' },
        { name: 'Assam', abbreviation: 'AS' },
        { name: 'Bihar', abbreviation: 'BR' },
        { name: 'Chandigarh', abbreviation: 'CH' },
        { name: 'Chhattisgarh', abbreviation: 'CT' },
        { name: 'Daman and Diu', abbreviation: 'DD' },
        { name: 'Delhi', abbreviation: 'DL' },
        { name: 'Dadra and Nagar Haveli', abbreviation: 'DN' },
        { name: 'Goa', abbreviation: 'GA' },
        { name: 'Gujarat', abbreviation: 'GJ' },
        { name: 'Himachal Pradesh', abbreviation: 'HP' },
        { name: 'Haryana', abbreviation: 'HR' },
        { name: 'Jharkhand', abbreviation: 'JH' },
        { name: 'Jammu and Kashmir', abbreviation: 'JK' },
        { name: 'Karnataka', abbreviation: 'KA' },
        { name: 'Kerala', abbreviation: 'KL' },
        { name: 'Lakshadweep', abbreviation: 'LD' },
        { name: 'Maharashtra', abbreviation: 'MH' },
        { name: 'Meghalaya', abbreviation: 'ML' },
        { name: 'Manipur', abbreviation: 'MN' },
        { name: 'Madhya Pradesh', abbreviation: 'MP' },
        { name: 'Mizoram', abbreviation: 'MZ' },
        { name: 'Nagaland', abbreviation: 'NL' },
        { name: 'Odisha', abbreviation: 'OR' },
        { name: 'Punjab', abbreviation: 'PB' },
        { name: 'Puducherry', abbreviation: 'PY' },
        { name: 'Rajasthan', abbreviation: 'RJ' },
        { name: 'Sikkim', abbreviation: 'SK' },
        { name: 'Telangana', abbreviation: 'TG' },
        { name: 'Tamil Nadu', abbreviation: 'TN' },
        { name: 'Tripura', abbreviation: 'TR' },
        { name: 'Uttar Pradesh', abbreviation: 'UP' },
        { name: 'Uttarakhand', abbreviation: 'UT' },
        { name: 'West Bengal', abbreviation: 'WB' },
    ];

    static readonly IT_STATES = [
        { name: 'Agrigento', abbreviation: 'AG' },
        { name: 'Alessandria', abbreviation: 'AL' },
        { name: 'Ancona', abbreviation: 'AN' },
        { name: 'Aosta', abbreviation: 'AO' },
        { name: 'Ascoli Piceno', abbreviation: 'AP' },
        {
            name: 'L\'Aquila', abbreviation: 'AQ'
        },
        { name: 'Arezzo', abbreviation: 'AR' },
        { name: 'Asti', abbreviation: 'AT' },
        { name: 'Avellino', abbreviation: 'AV' },
        { name: 'Bari', abbreviation: 'BA' },
        { name: 'Bergamo', abbreviation: 'BG' },
        { name: 'Biella', abbreviation: 'BI' },
        { name: 'Belluno', abbreviation: 'BL' },
        { name: 'Benevento', abbreviation: 'BN' },
        { name: 'Bologna', abbreviation: 'BO' },
        { name: 'Brindisi', abbreviation: 'BR' },
        { name: 'Brescia', abbreviation: 'BS' },
        { name: 'Barletta-Andria-Trani', abbreviation: 'BT' },
        { name: 'Bolzano', abbreviation: 'BZ' },
        { name: 'Cagliari', abbreviation: 'CA' },
        { name: 'Campobasso', abbreviation: 'CB' },
        { name: 'Caserta', abbreviation: 'CE' },
        { name: 'Chieti', abbreviation: 'CH' },
        { name: 'Carbonia-Iglesias', abbreviation: 'CI' },
        { name: 'Caltanissetta', abbreviation: 'CL' },
        { name: 'Cuneo', abbreviation: 'CN' },
        { name: 'Como', abbreviation: 'CO' },
        { name: 'Cremona', abbreviation: 'CR' },
        { name: 'Cosenza', abbreviation: 'CS' },
        { name: 'Catania', abbreviation: 'CT' },
        { name: 'Catanzaro', abbreviation: 'CZ' },
        { name: 'Enna', abbreviation: 'EN' },
        { name: 'Forlì-Cesena', abbreviation: 'FC' },
        { name: 'Ferrara', abbreviation: 'FE' },
        { name: 'Foggia', abbreviation: 'FG' },
        { name: 'Florence', abbreviation: 'FI' },
        { name: 'Fermo', abbreviation: 'FM' },
        { name: 'Frosinone', abbreviation: 'FR' },
        { name: 'Genoa', abbreviation: 'GE' },
        { name: 'Gorizia', abbreviation: 'GO' },
        { name: 'Grosseto', abbreviation: 'GR' },
        { name: 'Imperia', abbreviation: 'IM' },
        { name: 'Isernia', abbreviation: 'IS' },
        { name: 'Crotone', abbreviation: 'KR' },
        { name: 'Lecco', abbreviation: 'LC' },
        { name: 'Lecce', abbreviation: 'LE' },
        { name: 'Livorno', abbreviation: 'LI' },
        { name: 'Lodi', abbreviation: 'LO' },
        { name: 'Latina', abbreviation: 'LT' },
        { name: 'Lucca', abbreviation: 'LU' },
        { name: 'Monza and Brianza', abbreviation: 'MB' },
        { name: 'Macerata', abbreviation: 'MC' },
        { name: 'Messina', abbreviation: 'ME' },
        { name: 'Milan', abbreviation: 'MI' },
        { name: 'Mantua', abbreviation: 'MN' },
        { name: 'Modena', abbreviation: 'MO' },
        { name: 'Massa and Carrara', abbreviation: 'MS' },
        { name: 'Matera', abbreviation: 'MT' },
        { name: 'Naples', abbreviation: 'NA' },
        { name: 'Novara', abbreviation: 'NO' },
        { name: 'Nuoro', abbreviation: 'NU' },
        { name: 'Ogliastra', abbreviation: 'OG' },
        { name: 'Oristano', abbreviation: 'OR' },
        { name: 'Olbia-Tempio', abbreviation: 'OT' },
        { name: 'Palermo', abbreviation: 'PA' },
        { name: 'Piacenza', abbreviation: 'PC' },
        { name: 'Padua', abbreviation: 'PD' },
        { name: 'Pescara', abbreviation: 'PE' },
        { name: 'Perugia', abbreviation: 'PG' },
        { name: 'Pisa', abbreviation: 'PI' },
        { name: 'Pordenone', abbreviation: 'PN' },
        { name: 'Prato', abbreviation: 'PO' },
        { name: 'Parma', abbreviation: 'PR' },
        { name: 'Pistoia', abbreviation: 'PT' },
        { name: 'Pesaro and Urbino', abbreviation: 'PU' },
        { name: 'Pavia', abbreviation: 'PV' },
        { name: 'Potenza', abbreviation: 'PZ' },
        { name: 'Ravenna', abbreviation: 'RA' },
        { name: 'Reggio Calabria', abbreviation: 'RC' },
        { name: 'Reggio Emilia', abbreviation: 'RE' },
        { name: 'Ragusa', abbreviation: 'RG' },
        { name: 'Rieti', abbreviation: 'RI' },
        { name: 'Rome', abbreviation: 'RM' },
        { name: 'Rimini', abbreviation: 'RN' },
        { name: 'Rovigo', abbreviation: 'RO' },
        { name: 'Salerno', abbreviation: 'SA' },
        { name: 'Siena', abbreviation: 'SI' },
        { name: 'Sondrio', abbreviation: 'SO' },
        { name: 'La Spezia', abbreviation: 'SP' },
        { name: 'Syracuse', abbreviation: 'SR' },
        { name: 'Sassari', abbreviation: 'SS' },
        { name: 'Savona', abbreviation: 'SV' },
        { name: 'Taranto', abbreviation: 'TA' },
        { name: 'Teramo', abbreviation: 'TE' },
        { name: 'Trento', abbreviation: 'TN' },
        { name: 'Turin', abbreviation: 'TO' },
        { name: 'Trapani', abbreviation: 'TP' },
        { name: 'Terni', abbreviation: 'TR' },
        { name: 'Trieste', abbreviation: 'TS' },
        { name: 'Treviso', abbreviation: 'TV' },
        { name: 'Udine', abbreviation: 'UD' },
        { name: 'Varese', abbreviation: 'VA' },
        { name: 'Verbano-Cusio-Ossola', abbreviation: 'VB' },
        { name: 'Vercelli', abbreviation: 'VC' },
        { name: 'Venice', abbreviation: 'VE' },
        { name: 'Vicenza', abbreviation: 'VI' },
        { name: 'Verona', abbreviation: 'VR' },
        { name: 'Medio Campidano', abbreviation: 'VS' },
        { name: 'Viterbo', abbreviation: 'VT' },
        { name: 'Vibo Valentia', abbreviation: 'VV' },
    ];

    static readonly MX_STATES = [
        { name: 'Aguascalientes', abbreviation: 'AG' },
        { name: 'Baja California', abbreviation: 'BC' },
        { name: 'Baja California Sur', abbreviation: 'BS' },
        { name: 'Chihuahua', abbreviation: 'CH' },
        { name: 'Colima', abbreviation: 'CL' },
        { name: 'Campeche', abbreviation: 'CM' },
        { name: 'Coahuila', abbreviation: 'CO' },
        { name: 'Chiapas', abbreviation: 'CS' },
        { name: 'Federal District', abbreviation: 'DF' },
        { name: 'Durango', abbreviation: 'DG' },
        { name: 'Guerrero', abbreviation: 'GR' },
        { name: 'Guanajuato', abbreviation: 'GT' },
        { name: 'Hidalgo', abbreviation: 'HG' },
        { name: 'Jalisco', abbreviation: 'JA' },
        { name: 'Mexico State', abbreviation: 'ME' },
        { name: 'Michoacán', abbreviation: 'MI' },
        { name: 'Morelos', abbreviation: 'MO' },
        { name: 'Nayarit', abbreviation: 'NA' },
        { name: 'Nuevo León', abbreviation: 'NL' },
        { name: 'Oaxaca', abbreviation: 'OA' },
        { name: 'Puebla', abbreviation: 'PB' },
        { name: 'Querétaro', abbreviation: 'QE' },
        { name: 'Quintana Roo', abbreviation: 'QR' },
        { name: 'Sinaloa', abbreviation: 'SI' },
        { name: 'San Luis Potosí', abbreviation: 'SL' },
        { name: 'Sonora', abbreviation: 'SO' },
        { name: 'Tabasco', abbreviation: 'TB' },
        { name: 'Tlaxcala', abbreviation: 'TL' },
        { name: 'Tamaulipas', abbreviation: 'TM' },
        { name: 'Veracruz', abbreviation: 'VE' },
        { name: 'Yucatán', abbreviation: 'YU' },
        { name: 'Zacatecas', abbreviation: 'ZA' },
    ];

    static readonly COUNTRIES: Country[] = [
        { countryCode: 'US', name: 'United States' },
        { countryCode: 'GB', name: 'United Kingdom', vat: { ecVatable: false, ukVatable: true } },
        { countryCode: 'AL', name: 'Albania' },
        { countryCode: 'DZ', name: 'Algeria' },
        { countryCode: 'AD', name: 'Andorra' },
        { countryCode: 'AO', name: 'Angola' },
        { countryCode: 'AI', name: 'Anguilla' },
        { countryCode: 'AQ', name: 'Antarctica' },
        { countryCode: 'AG', name: 'Antigua And Barbuda' },
        { countryCode: 'AR', name: 'Argentina' },
        { countryCode: 'AM', name: 'Armenia' },
        { countryCode: 'AW', name: 'Aruba' },
        { countryCode: 'AU', name: 'Australia' },
        { countryCode: 'AT', name: 'Austria', vat: { ecVatable: true } },
        { countryCode: 'AZ', name: 'Azerbaijan' },
        { countryCode: 'BS', name: 'Bahamas' },
        { countryCode: 'BH', name: 'Bahrain' },
        { countryCode: 'BD', name: 'Bangladesh' },
        { countryCode: 'BB', name: 'Barbados' },
        // { countryCode: 'BY', name: 'Belarus' },
        { countryCode: 'BE', name: 'Belgium', vat: { ecVatable: true } },
        { countryCode: 'BZ', name: 'Belize' },
        { countryCode: 'BJ', name: 'Benin' },
        { countryCode: 'BM', name: 'Bermuda' },
        { countryCode: 'BT', name: 'Bhutan' },
        { countryCode: 'BO', name: 'Bolivia' },
        { countryCode: 'BA', name: 'Bosnia And Herzegovina' },
        { countryCode: 'BW', name: 'Botswana' },
        { countryCode: 'BV', name: 'Bouvet Island' },
        { countryCode: 'BR', name: 'Brazil' },
        { countryCode: 'IO', name: 'British Indian Ocean Territory' },
        { countryCode: 'BN', name: 'Brunei Darussalam' },
        { countryCode: 'BG', name: 'Bulgaria', vat: { ecVatable: true } },
        { countryCode: 'BF', name: 'Burkina Faso' },
        { countryCode: 'BI', name: 'Burundi' },
        { countryCode: 'KH', name: 'Cambodia' },
        { countryCode: 'CM', name: 'Cameroon' },
        { countryCode: 'CA', name: 'Canada' },
        { countryCode: 'CV', name: 'Cape Verde' },
        { countryCode: 'KY', name: 'Cayman Islands' },
        // { countryCode: 'CF', name: 'Central African Republic' },
        { countryCode: 'TD', name: 'Chad' },
        { countryCode: 'CL', name: 'Chile' },
        { countryCode: 'CN', name: 'China' },
        { countryCode: 'TW', name: 'Taiwan' },
        { countryCode: 'CX', name: 'Christmas Island' },
        { countryCode: 'CC', name: 'Cocos (keeling) Islands' },
        { countryCode: 'CO', name: 'Colombia' },
        { countryCode: 'KM', name: 'Comoros' },
        { countryCode: 'CG', name: 'Congo' },
        // { countryCode: 'CD', name: 'Congo, The Democratic Republic Of The' },
        { countryCode: 'CK', name: 'Cook Islands' },
        { countryCode: 'CR', name: 'Costa Rica' },
        { countryCode: 'CI', name: 'Cote D\'ivoire' },
        { countryCode: 'HR', name: 'Croatia', vat: { ecVatable: true } },
        { countryCode: 'CY', name: 'Cyprus' },
        { countryCode: 'CZ', name: 'Czech Republic', vat: { ecVatable: true } },
        { countryCode: 'DK', name: 'Denmark', vat: { ecVatable: true } },
        { countryCode: 'DJ', name: 'Djibouti' },
        { countryCode: 'DM', name: 'Dominica' },
        { countryCode: 'DO', name: 'Dominican Republic' },
        { countryCode: 'TP', name: 'East Timor' },
        { countryCode: 'EC', name: 'Ecuador' },
        { countryCode: 'EG', name: 'Egypt' },
        { countryCode: 'SV', name: 'El Salvador' },
        { countryCode: 'GQ', name: 'Equatorial Guinea' },
        { countryCode: 'ER', name: 'Eritrea' },
        { countryCode: 'EE', name: 'Estonia', vat: { ecVatable: true } },
        // { countryCode: 'ET', name: 'Ethiopia' },
        { countryCode: 'FK', name: 'Falkland Islands (malvinas)' },
        { countryCode: 'FO', name: 'Faroe Islands' },
        { countryCode: 'FJ', name: 'Fiji' },
        { countryCode: 'FI', name: 'Finland', vat: { ecVatable: true } },
        { countryCode: 'FR', name: 'France', vat: { ecVatable: true } },
        { countryCode: 'GF', name: 'French Guiana' },
        { countryCode: 'PF', name: 'French Polynesia' },
        { countryCode: 'TF', name: 'French Southern Territories' },
        { countryCode: 'GA', name: 'Gabon' },
        { countryCode: 'GM', name: 'Gambia' },
        { countryCode: 'GE', name: 'Georgia' },
        { countryCode: 'DE', name: 'Germany', vat: { ecVatable: true } },
        { countryCode: 'GH', name: 'Ghana' },
        { countryCode: 'GI', name: 'Gibraltar' },
        { countryCode: 'GR', name: 'Greece', vat: { ecVatable: true } },
        { countryCode: 'GL', name: 'Greenland' },
        { countryCode: 'GD', name: 'Grenada' },
        { countryCode: 'GP', name: 'Guadeloupe' },
        { countryCode: 'GU', name: 'Guam' },
        { countryCode: 'GT', name: 'Guatemala' },
        { countryCode: 'GG', name: 'Guernsey' },
        { countryCode: 'GN', name: 'Guinea' },
        { countryCode: 'GW', name: 'Guinea-bissau' },
        { countryCode: 'GY', name: 'Guyana' },
        { countryCode: 'HT', name: 'Haiti' },
        { countryCode: 'HM', name: 'Heard Island And Mcdonald Islands' },
        { countryCode: 'VA', name: 'Holy See (vatican City State)' },
        { countryCode: 'HN', name: 'Honduras' },
        { countryCode: 'HU', name: 'Hungary', vat: { ecVatable: true } },
        { countryCode: 'IS', name: 'Iceland' },
        { countryCode: 'IN', name: 'India' },
        { countryCode: 'ID', name: 'Indonesia' },
        // { countryCode: 'IR', name: 'Iran, Islamic Republic Of' },
        // { countryCode: 'IQ', name: 'Iraq' },
        { countryCode: 'IE', name: 'Ireland', vat: { ecVatable: true } },
        { countryCode: 'IL', name: 'Israel' },
        { countryCode: 'IM', name: 'Isle of Man', vat: { ecVatable: false, ukVatable: true } },
        { countryCode: 'IT', name: 'Italy', vat: { ecVatable: true } },
        { countryCode: 'JM', name: 'Jamaica' },
        { countryCode: 'JP', name: 'Japan' },
        { countryCode: 'JE', name: 'Jersey' },
        { countryCode: 'JO', name: 'Jordan' },
        { countryCode: 'KZ', name: 'Kazakhstan' },
        { countryCode: 'KE', name: 'Kenya' },
        { countryCode: 'KI', name: 'Kiribati' },
        { countryCode: 'KR', name: 'Korea, Republic Of' },
        { countryCode: 'XK', name: 'Kosovo' },
        { countryCode: 'KW', name: 'Kuwait' },
        { countryCode: 'KG', name: 'Kyrgyzstan' },
        { countryCode: 'LA', name: 'Lao People\'s Democratic Republic' },
        { countryCode: 'LV', name: 'Latvia', vat: { ecVatable: true } },
        // { countryCode: 'LB', name: 'Lebanon' },
        { countryCode: 'LS', name: 'Lesotho' },
        { countryCode: 'LR', name: 'Liberia' },
        // { countryCode: 'LY', name: 'Libyan Arab Jamahiriya' },
        { countryCode: 'LI', name: 'Liechtenstein' },
        { countryCode: 'LT', name: 'Lithuania', vat: { ecVatable: true } },
        { countryCode: 'LU', name: 'Luxembourg', vat: { ecVatable: true } },
        { countryCode: 'MO', name: 'Macau' },
        { countryCode: 'MK', name: 'Macedonia, The Former Yugoslav Republic Of' },
        { countryCode: 'MG', name: 'Madagascar' },
        { countryCode: 'MW', name: 'Malawi' },
        { countryCode: 'MY', name: 'Malaysia' },
        { countryCode: 'MV', name: 'Maldives' },
        // { countryCode: 'ML', name: 'Mali' },
        { countryCode: 'MT', name: 'Malta', vat: { ecVatable: true } },
        { countryCode: 'MH', name: 'Marshall Islands' },
        { countryCode: 'MQ', name: 'Martinique' },
        { countryCode: 'MR', name: 'Mauritania' },
        { countryCode: 'MU', name: 'Mauritius' },
        { countryCode: 'YT', name: 'Mayotte' },
        { countryCode: 'MX', name: 'Mexico' },
        { countryCode: 'FM', name: 'Micronesia, Federated States Of' },
        { countryCode: 'MD', name: 'Moldova, Republic Of' },
        { countryCode: 'MC', name: 'Monaco', vat: { ecVatable: true } },
        { countryCode: 'MN', name: 'Mongolia' },
        { countryCode: 'MS', name: 'Montserrat' },
        { countryCode: 'ME', name: 'Montenegro' },
        { countryCode: 'MA', name: 'Morocco' },
        { countryCode: 'MZ', name: 'Mozambique' },
        { countryCode: 'MM', name: 'Myanmar' },
        { countryCode: 'NA', name: 'Namibia' },
        { countryCode: 'NR', name: 'Nauru' },
        { countryCode: 'NP', name: 'Nepal' },
        { countryCode: 'NL', name: 'Netherlands', vat: { ecVatable: true } },
        { countryCode: 'CW', name: 'Curacao' },
        { countryCode: 'SX', name: 'Sint Maarten (Dutch part)' },
        { countryCode: 'NC', name: 'New Caledonia' },
        { countryCode: 'NZ', name: 'New Zealand' },
        // { countryCode: 'NI', name: 'Nicaragua' },
        { countryCode: 'NE', name: 'Niger' },
        { countryCode: 'NG', name: 'Nigeria' },
        { countryCode: 'NU', name: 'Niue' },
        { countryCode: 'NF', name: 'Norfolk Island' },
        { countryCode: 'MP', name: 'Northern Mariana Islands' },
        { countryCode: 'NO', name: 'Norway' },
        { countryCode: 'OM', name: 'Oman' },
        { countryCode: 'PK', name: 'Pakistan' },
        { countryCode: 'PW', name: 'Palau' },
        { countryCode: 'PS', name: 'Palestinian Territory, Occupied' },
        { countryCode: 'PA', name: 'Panama' },
        { countryCode: 'PG', name: 'Papua New Guinea' },
        { countryCode: 'PY', name: 'Paraguay' },
        { countryCode: 'PE', name: 'Peru' },
        { countryCode: 'PH', name: 'Philippines' },
        { countryCode: 'PN', name: 'Pitcairn' },
        { countryCode: 'PL', name: 'Poland', vat: { ecVatable: true } },
        { countryCode: 'PT', name: 'Portugal', vat: { ecVatable: true } },
        { countryCode: 'PR', name: 'Puerto Rico' },
        { countryCode: 'QA', name: 'Qatar' },
        { countryCode: 'RE', name: 'Reunion' },
        { countryCode: 'RO', name: 'Romania', vat: { ecVatable: true } },
        // { countryCode: 'RU', name: 'Russian Federation' },
        { countryCode: 'RW', name: 'Rwanda' },
        { countryCode: 'SH', name: 'Saint Helena' },
        { countryCode: 'KN', name: 'Saint Kitts And Nevis' },
        { countryCode: 'LC', name: 'Saint Lucia' },
        { countryCode: 'PM', name: 'Saint Pierre And Miquelon' },
        { countryCode: 'VC', name: 'Saint Vincent And The Grenadines' },
        { countryCode: 'WS', name: 'Samoa' },
        { countryCode: 'SM', name: 'San Marino' },
        { countryCode: 'ST', name: 'Sao Tome And Principe' },
        { countryCode: 'SA', name: 'Saudi Arabia' },
        { countryCode: 'SN', name: 'Senegal' },
        { countryCode: 'RS', name: 'Serbia' },
        { countryCode: 'SC', name: 'Seychelles' },
        { countryCode: 'SL', name: 'Sierra Leone' },
        { countryCode: 'SG', name: 'Singapore' },
        { countryCode: 'SK', name: 'Slovakia', vat: { ecVatable: true } },
        { countryCode: 'SI', name: 'Slovenia', vat: { ecVatable: true } },
        { countryCode: 'SB', name: 'Solomon Islands' },
        { countryCode: 'ZA', name: 'South Africa' },
        { countryCode: 'GS', name: 'South Georgia And The South Sandwich Islands' },
        { countryCode: 'ES', name: 'Spain', vat: { ecVatable: true } },
        { countryCode: 'LK', name: 'Sri Lanka' },
        { countryCode: 'SR', name: 'Suriname' },
        { countryCode: 'SJ', name: 'Svalbard And Jan Mayen' },
        { countryCode: 'SZ', name: 'Swaziland' },
        { countryCode: 'SE', name: 'Sweden', vat: { ecVatable: true } },
        { countryCode: 'CH', name: 'Switzerland' },
        { countryCode: 'TJ', name: 'Tajikistan' },
        { countryCode: 'TZ', name: 'Tanzania, United Republic Of' },
        { countryCode: 'TH', name: 'Thailand' },
        { countryCode: 'TG', name: 'Togo' },
        { countryCode: 'TK', name: 'Tokelau' },
        { countryCode: 'TO', name: 'Tonga' },
        { countryCode: 'TT', name: 'Trinidad And Tobago' },
        { countryCode: 'TN', name: 'Tunisia' },
        { countryCode: 'TR', name: 'Turkey' },
        { countryCode: 'TM', name: 'Turkmenistan' },
        { countryCode: 'TC', name: 'Turks And Caicos Islands' },
        { countryCode: 'TV', name: 'Tuvalu' },
        { countryCode: 'UG', name: 'Uganda' },
        { countryCode: 'UA', name: 'Ukraine' },
        { countryCode: 'AE', name: 'United Arab Emirates' },
        { countryCode: 'UY', name: 'Uruguay' },
        { countryCode: 'UZ', name: 'Uzbekistan' },
        { countryCode: 'VU', name: 'Vanuatu' },
        // { countryCode: 'VE', name: 'Venezuela' },
        { countryCode: 'VN', name: 'Viet Nam' },
        { countryCode: 'VG', name: 'Virgin Islands, British' },
        { countryCode: 'WF', name: 'Wallis And Futuna' },
        { countryCode: 'EH', name: 'Western Sahara' },
        // { countryCode: 'YE', name: 'Yemen' },
        { countryCode: 'ZM', name: 'Zambia' },
        { countryCode: 'ZW', name: 'Zimbabwe' }
    ];

    static postcodeRegex = [
        { countryCode: 'GB', regex: '^(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4})$' },
        { countryCode: 'JE', regex: '^JE\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$' },
        { countryCode: 'GG', regex: '^GY\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$' },
        { countryCode: 'IM', regex: '^IM\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$' },
        { countryCode: 'US', regex: '^(\\d{5}(\\-\\d{4})?)?$' },
        { countryCode: 'CA', regex: '^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d$' },
        { countryCode: 'DE', regex: '^\\d{5}$' },
        { countryCode: 'JP', regex: '^\\d{3}-\\d{4}$' },
        { countryCode: 'FR', regex: '^\\d{2}[ ]?\\d{3}$' },
        { countryCode: 'AU', regex: '^\\d{4}$' },
        { countryCode: 'IT', regex: '^\\d{5}$' },
        { countryCode: 'CH', regex: '^\\d{4}$' },
        { countryCode: 'AT', regex: '^\\d{4}$' },
        { countryCode: 'ES', regex: '^\\d{5}$' },
        { countryCode: 'NL', regex: '^\\d{4}[ ]?[A-Z]{2}$' },
        { countryCode: 'BE', regex: '^\\d{4}$' },
        { countryCode: 'DK', regex: '^\\d{4}$' },
        { countryCode: 'SE', regex: '^\\d{3}[ ]?\\d{2}$' },
        { countryCode: 'NO', regex: '^\\d{4}$' },
        { countryCode: 'BR', regex: '^\\d{5}[\\-]?\\d{3}$' },
        { countryCode: 'PT', regex: '^\\d{4}([\\-]\\d{3})?$' },
        { countryCode: 'FI', regex: '^\\d{5}$' },
        { countryCode: 'AX', regex: '^22\\d{3}$' },
        { countryCode: 'KR', regex: '^\\d{3}[\\-]\\d{3}|\\d{5}$' },
        { countryCode: 'CN', regex: '^\\d{6}$' },
        { countryCode: 'TW', regex: '^\\d+(?:-\\d+)*$' },
        { countryCode: 'SG', regex: '^\\d{6}$' },
        { countryCode: 'DZ', regex: '^\\d{5}$' },
        { countryCode: 'AD', regex: '^AD\\d{3}$' },
        { countryCode: 'AR', regex: '^([A-HJ-NP-Z])?\\d{4}([A-Z]{3})?$' },
        { countryCode: 'AM', regex: '^(37)?\\d{4}$' },
        { countryCode: 'AZ', regex: '^\\d{4}$' },
        { countryCode: 'BH', regex: '^((1[0-2]|[2-9])\\d{2})?$' },
        { countryCode: 'BD', regex: '^\\d{4}$' },
        { countryCode: 'BB', regex: '^(BB\\d{5})?$' },
        { countryCode: 'BY', regex: '^\\d{6}$' },
        { countryCode: 'BM', regex: '^[A-Z]{2}[ ]?[A-Z0-9]{2}$' },
        { countryCode: 'BA', regex: '^\\d{5}$' },
        { countryCode: 'IO', regex: '^BBND 1ZZ$' },
        { countryCode: 'BN', regex: '^[A-Z]{2}[ ]?\\d{4}$' },
        { countryCode: 'BG', regex: '^\\d{4}$' },
        { countryCode: 'KH', regex: '^\\d{5}$' },
        { countryCode: 'CV', regex: '^\\d{4}$' },
        { countryCode: 'CL', regex: '^\\d{7}$' },
        { countryCode: 'CR', regex: '^\\d{4,5}|\\d{3}-\\d{4}$' },
        { countryCode: 'HR', regex: '^\\d{5}$' },
        { countryCode: 'CY', regex: '^\\d{4}$' },
        { countryCode: 'CZ', regex: '^\\d{3}[ ]?\\d{2}$' },
        { countryCode: 'DO', regex: '^\\d{5}$' },
        { countryCode: 'EC', regex: '^([A-Z]\\d{4}[A-Z]|(?:[A-Z]{2})?\\d{6})?$' },
        { countryCode: 'EG', regex: '^\\d{5}$' },
        { countryCode: 'EE', regex: '^\\d{5}$' },
        { countryCode: 'FO', regex: '^\\d{3}$' },
        { countryCode: 'GE', regex: '^\\d{4}$' },
        { countryCode: 'GR', regex: '^\\d{3}[ ]?\\d{2}$' },
        { countryCode: 'GL', regex: '^39\\d{2}$' },
        { countryCode: 'GT', regex: '^\\d{5}$' },
        { countryCode: 'HT', regex: '^\\d{4}$' },
        { countryCode: 'HN', regex: '^(?:\\d{5})?$' },
        { countryCode: 'HU', regex: '^\\d{4}$' },
        { countryCode: 'IS', regex: '^\\d{3}$' },
        { countryCode: 'IN', regex: '^\\d{6}$' },
        { countryCode: 'ID', regex: '^\\d{5}$' },
        { countryCode: 'IL', regex: '^\\d{7}$' },
        { countryCode: 'JO', regex: '^\\d{5}$' },
        { countryCode: 'KZ', regex: '^\\d{6}$' },
        { countryCode: 'KE', regex: '^\\d{5}$' },
        { countryCode: 'KW', regex: '^\\d{5}$' },
        { countryCode: 'LA', regex: '^\\d{5}$' },
        { countryCode: 'LV', regex: '^\\d{4}$' },
        { countryCode: 'LB', regex: '^(\\d{4}([ ]?\\d{4})?)?$' },
        { countryCode: 'LI', regex: '^(948[5-9])|(949[0-7])$' },
        { countryCode: 'LT', regex: '^\\d{5}$' },
        { countryCode: 'LU', regex: '^\\d{4}$' },
        { countryCode: 'MK', regex: '^\\d{4}$' },
        { countryCode: 'MY', regex: '^\\d{5}$' },
        { countryCode: 'MV', regex: '^\\d{5}$' },
        { countryCode: 'MT', regex: '^[A-Z]{3}[ ]?\\d{2,4}$' },
        { countryCode: 'MX', regex: '^\\d{5}$' },
        { countryCode: 'MD', regex: '^\\d{4}$' },
        { countryCode: 'MC', regex: '^980\\d{2}$' },
        { countryCode: 'MA', regex: '^\\d{5}$' },
        { countryCode: 'NP', regex: '^\\d{5}$' },
        { countryCode: 'NZ', regex: '^\\d{4}$' },
        { countryCode: 'NI', regex: '^((\\d{4}-)?\\d{3}-\\d{3}(-\\d{1})?)?$' },
        { countryCode: 'NG', regex: '^(\\d{6})?$' },
        { countryCode: 'OM', regex: '^(PC )?\\d{3}$' },
        { countryCode: 'PK', regex: '^\\d{5}$' },
        { countryCode: 'PY', regex: '^\\d{4}$' },
        { countryCode: 'PH', regex: '^\\d{4}$' },
        { countryCode: 'PL', regex: '^\\d{2}-\\d{3}$' },
        { countryCode: 'PR', regex: '^00[679]\\d{2}([ \\-]\\d{4})?$' },
        { countryCode: 'RO', regex: '^\\d{6}$' },
        { countryCode: 'RU', regex: '^\\d{6}$' },
        { countryCode: 'SM', regex: '^4789\\d$' },
        { countryCode: 'SA', regex: '^\\d{5}$' },
        { countryCode: 'SN', regex: '^\\d{5}$' },
        { countryCode: 'SK', regex: '^\\d{3}[ ]?\\d{2}$' },
        { countryCode: 'SI', regex: '^\\d{4}$' },
        { countryCode: 'ZA', regex: '^\\d{4}$' },
        { countryCode: 'LK', regex: '^\\d{5}$' },
        { countryCode: 'TJ', regex: '^\\d{6}$' },
        { countryCode: 'TH', regex: '^\\d{5}$' },
        { countryCode: 'TN', regex: '^\\d{4}$' },
        { countryCode: 'TR', regex: '^\\d{5}$' },
        { countryCode: 'TM', regex: '^\\d{6}$' },
        { countryCode: 'UA', regex: '^\\d{5}$' },
        { countryCode: 'UY', regex: '^\\d{5}$' },
        { countryCode: 'UZ', regex: '^\\d{6}$' },
        { countryCode: 'VA', regex: '^00120$' },
        { countryCode: 'VE', regex: '^\\d{4}$' },
        { countryCode: 'ZM', regex: '^\\d{5}$' },
        { countryCode: 'AS', regex: '^96799$' },
        { countryCode: 'CC', regex: '^6799$' },
        { countryCode: 'CK', regex: '^\\d{4}$' },
        { countryCode: 'RS', regex: '^\\d{5}$' },
        { countryCode: 'ME', regex: '^8\\d{4}$' },
        { countryCode: 'CS', regex: '^\\d{5}$' },
        { countryCode: 'YU', regex: '^\\d{5}$' },
        { countryCode: 'CX', regex: '^6798$' },
        { countryCode: 'ET', regex: '^\\d{5}$' },
        { countryCode: 'FK', regex: '^FIQQ 1ZZ$' },
        { countryCode: 'NF', regex: '^2899$' },
        { countryCode: 'FM', regex: '^(9694[1-4])([ \\-]\\d{4})?$' },
        { countryCode: 'GF', regex: '^9[78]3\\d{2}$' },
        { countryCode: 'GN', regex: '^\\d{3}$' },
        { countryCode: 'GP', regex: '^9[78][01]\\d{2}$' },
        { countryCode: 'GS', regex: '^SIQQ 1ZZ$' },
        { countryCode: 'GU', regex: '^969[123]\\d([ \\-]\\d{4})?$' },
        { countryCode: 'GW', regex: '^\\d{4}$' },
        { countryCode: 'HM', regex: '^\\d{4}$' },
        { countryCode: 'IQ', regex: '^\\d{5}$' },
        { countryCode: 'KG', regex: '^\\d{6}$' },
        { countryCode: 'LR', regex: '^\\d{4}$' },
        { countryCode: 'LS', regex: '^\\d{3}$' },
        { countryCode: 'MG', regex: '^\\d{3}$' },
        { countryCode: 'MH', regex: '^969[67]\\d([ \\-]\\d{4})?$' },
        { countryCode: 'MN', regex: '^\\d{5}$' },
        { countryCode: 'MP', regex: '^9695[012]([ \\-]\\d{4})?$' },
        { countryCode: 'MQ', regex: '^9[78]2\\d{2}$' },
        { countryCode: 'NC', regex: '^988\\d{2}$' },
        { countryCode: 'NE', regex: '^\\d{4}$' },
        { countryCode: 'VI', regex: '^008(([0-4]\\d)|(5[01]))([ \\-]\\d{4})?$' },
        { countryCode: 'PF', regex: '^987\\d{2}$' },
        { countryCode: 'PG', regex: '^\\d{3}$' },
        { countryCode: 'PM', regex: '^9[78]5\\d{2}$' },
        { countryCode: 'PN', regex: '^PCRN 1ZZ$' },
        { countryCode: 'PW', regex: '^96940$' },
        { countryCode: 'RE', regex: '^9[78]4\\d{2}$' },
        { countryCode: 'SH', regex: '^(ASCN|STHL) 1ZZ$' },
        { countryCode: 'SJ', regex: '^\\d{4}$' },
        { countryCode: 'SO', regex: '^\\d{5}$' },
        { countryCode: 'SZ', regex: '^[HLMS]\\d{3}$' },
        { countryCode: 'TC', regex: '^TKCA 1ZZ$' },
        { countryCode: 'WF', regex: '^986\\d{2}$' },
        { countryCode: 'XK', regex: '^\\d{5}$' },
        { countryCode: 'YT', regex: '^976\\d{2}$' }
    ];

    static countryCallingCodes = [
        {
            "name": "Afghanistan",
            "dial_code": "93",
            "code": "AF"
        },
        {
            "name": "Aland Islands",
            "dial_code": "358",
            "code": "AX"
        },
        {
            "name": "Albania",
            "dial_code": "355",
            "code": "AL"
        },
        {
            "name": "Algeria",
            "dial_code": "213",
            "code": "DZ"
        },
        {
            "name": "AmericanSamoa",
            "dial_code": "1684",
            "code": "AS"
        },
        {
            "name": "Andorra",
            "dial_code": "376",
            "code": "AD"
        },
        {
            "name": "Angola",
            "dial_code": "244",
            "code": "AO"
        },
        {
            "name": "Anguilla",
            "dial_code": "1264",
            "code": "AI"
        },
        {
            "name": "Antarctica",
            "dial_code": "672",
            "code": "AQ"
        },
        {
            "name": "Antigua and Barbuda",
            "dial_code": "1268",
            "code": "AG"
        },
        {
            "name": "Argentina",
            "dial_code": "54",
            "code": "AR"
        },
        {
            "name": "Armenia",
            "dial_code": "374",
            "code": "AM"
        },
        {
            "name": "Aruba",
            "dial_code": "297",
            "code": "AW"
        },
        {
            "name": "Australia",
            "dial_code": "61",
            "code": "AU"
        },
        {
            "name": "Austria",
            "dial_code": "43",
            "code": "AT"
        },
        {
            "name": "Azerbaijan",
            "dial_code": "994",
            "code": "AZ"
        },
        {
            "name": "Bahamas",
            "dial_code": "1242",
            "code": "BS"
        },
        {
            "name": "Bahrain",
            "dial_code": "973",
            "code": "BH"
        },
        {
            "name": "Bangladesh",
            "dial_code": "880",
            "code": "BD"
        },
        {
            "name": "Barbados",
            "dial_code": "1246",
            "code": "BB"
        },
        {
            "name": "Belarus",
            "dial_code": "375",
            "code": "BY"
        },
        {
            "name": "Belgium",
            "dial_code": "32",
            "code": "BE"
        },
        {
            "name": "Belize",
            "dial_code": "501",
            "code": "BZ"
        },
        {
            "name": "Benin",
            "dial_code": "229",
            "code": "BJ"
        },
        {
            "name": "Bermuda",
            "dial_code": "1441",
            "code": "BM"
        },
        {
            "name": "Bhutan",
            "dial_code": "975",
            "code": "BT"
        },
        {
            "name": "Bolivia, Plurinational State of",
            "dial_code": "591",
            "code": "BO"
        },
        {
            "name": "Bosnia and Herzegovina",
            "dial_code": "387",
            "code": "BA"
        },
        {
            "name": "Botswana",
            "dial_code": "267",
            "code": "BW"
        },
        {
            "name": "Brazil",
            "dial_code": "55",
            "code": "BR"
        },
        {
            "name": "British Indian Ocean Territory",
            "dial_code": "246",
            "code": "IO"
        },
        {
            "name": "Brunei Darussalam",
            "dial_code": "673",
            "code": "BN"
        },
        {
            "name": "Bulgaria",
            "dial_code": "359",
            "code": "BG"
        },
        {
            "name": "Burkina Faso",
            "dial_code": "226",
            "code": "BF"
        },
        {
            "name": "Burundi",
            "dial_code": "257",
            "code": "BI"
        },
        {
            "name": "Cambodia",
            "dial_code": "855",
            "code": "KH"
        },
        {
            "name": "Cameroon",
            "dial_code": "237",
            "code": "CM"
        },
        {
            "name": "Canada",
            "dial_code": "1",
            "code": "CA"
        },
        {
            "name": "Cape Verde",
            "dial_code": "238",
            "code": "CV"
        },
        {
            "name": "Cayman Islands",
            "dial_code": " 345",
            "code": "KY"
        },
        {
            "name": "Central African Republic",
            "dial_code": "236",
            "code": "CF"
        },
        {
            "name": "Chad",
            "dial_code": "235",
            "code": "TD"
        },
        {
            "name": "Chile",
            "dial_code": "56",
            "code": "CL"
        },
        {
            "name": "China",
            "dial_code": "86",
            "code": "CN"
        },
        {
            "name": "Christmas Island",
            "dial_code": "61",
            "code": "CX"
        },
        {
            "name": "Cocos (Keeling) Islands",
            "dial_code": "61",
            "code": "CC"
        },
        {
            "name": "Colombia",
            "dial_code": "57",
            "code": "CO"
        },
        {
            "name": "Comoros",
            "dial_code": "269",
            "code": "KM"
        },
        {
            "name": "Congo",
            "dial_code": "242",
            "code": "CG"
        },
        {
            "name": "Congo, The Democratic Republic of the Congo",
            "dial_code": "243",
            "code": "CD"
        },
        {
            "name": "Cook Islands",
            "dial_code": "682",
            "code": "CK"
        },
        {
            "name": "Costa Rica",
            "dial_code": "506",
            "code": "CR"
        },
        {
            "name": "Cote d'Ivoire",
            "dial_code": "225",
            "code": "CI"
        },
        {
            "name": "Croatia",
            "dial_code": "385",
            "code": "HR"
        },
        {
            "name": "Cuba",
            "dial_code": "53",
            "code": "CU"
        },
        {
            "name": "Cyprus",
            "dial_code": "357",
            "code": "CY"
        },
        {
            "name": "Czech Republic",
            "dial_code": "420",
            "code": "CZ"
        },
        {
            "name": "Denmark",
            "dial_code": "45",
            "code": "DK"
        },
        {
            "name": "Djibouti",
            "dial_code": "253",
            "code": "DJ"
        },
        {
            "name": "Dominica",
            "dial_code": "1767",
            "code": "DM"
        },
        {
            "name": "Dominican Republic",
            "dial_code": "1849",
            "code": "DO"
        },
        {
            "name": "Ecuador",
            "dial_code": "593",
            "code": "EC"
        },
        {
            "name": "Egypt",
            "dial_code": "20",
            "code": "EG"
        },
        {
            "name": "El Salvador",
            "dial_code": "503",
            "code": "SV"
        },
        {
            "name": "Equatorial Guinea",
            "dial_code": "240",
            "code": "GQ"
        },
        {
            "name": "Eritrea",
            "dial_code": "291",
            "code": "ER"
        },
        {
            "name": "Estonia",
            "dial_code": "372",
            "code": "EE"
        },
        {
            "name": "Ethiopia",
            "dial_code": "251",
            "code": "ET"
        },
        {
            "name": "Falkland Islands (Malvinas)",
            "dial_code": "500",
            "code": "FK"
        },
        {
            "name": "Faroe Islands",
            "dial_code": "298",
            "code": "FO"
        },
        {
            "name": "Fiji",
            "dial_code": "679",
            "code": "FJ"
        },
        {
            "name": "Finland",
            "dial_code": "358",
            "code": "FI"
        },
        {
            "name": "France",
            "dial_code": "33",
            "code": "FR"
        },
        {
            "name": "French Guiana",
            "dial_code": "594",
            "code": "GF"
        },
        {
            "name": "French Polynesia",
            "dial_code": "689",
            "code": "PF"
        },
        {
            "name": "Gabon",
            "dial_code": "241",
            "code": "GA"
        },
        {
            "name": "Gambia",
            "dial_code": "220",
            "code": "GM"
        },
        {
            "name": "Georgia",
            "dial_code": "995",
            "code": "GE"
        },
        {
            "name": "Germany",
            "dial_code": "49",
            "code": "DE"
        },
        {
            "name": "Ghana",
            "dial_code": "233",
            "code": "GH"
        },
        {
            "name": "Gibraltar",
            "dial_code": "350",
            "code": "GI"
        },
        {
            "name": "Greece",
            "dial_code": "30",
            "code": "GR"
        },
        {
            "name": "Greenland",
            "dial_code": "299",
            "code": "GL"
        },
        {
            "name": "Grenada",
            "dial_code": "1473",
            "code": "GD"
        },
        {
            "name": "Guadeloupe",
            "dial_code": "590",
            "code": "GP"
        },
        {
            "name": "Guam",
            "dial_code": "1671",
            "code": "GU"
        },
        {
            "name": "Guatemala",
            "dial_code": "502",
            "code": "GT"
        },
        {
            "name": "Guernsey",
            "dial_code": "44",
            "code": "GG"
        },
        {
            "name": "Guinea",
            "dial_code": "224",
            "code": "GN"
        },
        {
            "name": "Guinea-Bissau",
            "dial_code": "245",
            "code": "GW"
        },
        {
            "name": "Guyana",
            "dial_code": "595",
            "code": "GY"
        },
        {
            "name": "Haiti",
            "dial_code": "509",
            "code": "HT"
        },
        {
            "name": "Holy See (Vatican City State)",
            "dial_code": "379",
            "code": "VA"
        },
        {
            "name": "Honduras",
            "dial_code": "504",
            "code": "HN"
        },
        {
            "name": "Hong Kong",
            "dial_code": "852",
            "code": "HK"
        },
        {
            "name": "Hungary",
            "dial_code": "36",
            "code": "HU"
        },
        {
            "name": "Iceland",
            "dial_code": "354",
            "code": "IS"
        },
        {
            "name": "India",
            "dial_code": "91",
            "code": "IN"
        },
        {
            "name": "Indonesia",
            "dial_code": "62",
            "code": "ID"
        },
        {
            "name": "Iran, Islamic Republic of Persian Gulf",
            "dial_code": "98",
            "code": "IR"
        },
        {
            "name": "Iraq",
            "dial_code": "964",
            "code": "IQ"
        },
        {
            "name": "Ireland",
            "dial_code": "353",
            "code": "IE"
        },
        {
            "name": "Isle of Man",
            "dial_code": "44",
            "code": "IM"
        },
        {
            "name": "Israel",
            "dial_code": "972",
            "code": "IL"
        },
        {
            "name": "Italy",
            "dial_code": "39",
            "code": "IT"
        },
        {
            "name": "Jamaica",
            "dial_code": "1876",
            "code": "JM"
        },
        {
            "name": "Japan",
            "dial_code": "81",
            "code": "JP"
        },
        {
            "name": "Jersey",
            "dial_code": "44",
            "code": "JE"
        },
        {
            "name": "Jordan",
            "dial_code": "962",
            "code": "JO"
        },
        {
            "name": "Kazakhstan",
            "dial_code": "77",
            "code": "KZ"
        },
        {
            "name": "Kenya",
            "dial_code": "254",
            "code": "KE"
        },
        {
            "name": "Kiribati",
            "dial_code": "686",
            "code": "KI"
        },
        {
            "name": "Korea, Democratic People's Republic of Korea",
            "dial_code": "850",
            "code": "KP"
        },
        {
            "name": "Korea, Republic of South Korea",
            "dial_code": "82",
            "code": "KR"
        },
        {
            "name": "Kuwait",
            "dial_code": "965",
            "code": "KW"
        },
        {
            "name": "Kyrgyzstan",
            "dial_code": "996",
            "code": "KG"
        },
        {
            "name": "Laos",
            "dial_code": "856",
            "code": "LA"
        },
        {
            "name": "Latvia",
            "dial_code": "371",
            "code": "LV"
        },
        {
            "name": "Lebanon",
            "dial_code": "961",
            "code": "LB"
        },
        {
            "name": "Lesotho",
            "dial_code": "266",
            "code": "LS"
        },
        {
            "name": "Liberia",
            "dial_code": "231",
            "code": "LR"
        },
        {
            "name": "Libyan Arab Jamahiriya",
            "dial_code": "218",
            "code": "LY"
        },
        {
            "name": "Liechtenstein",
            "dial_code": "423",
            "code": "LI"
        },
        {
            "name": "Lithuania",
            "dial_code": "370",
            "code": "LT"
        },
        {
            "name": "Luxembourg",
            "dial_code": "352",
            "code": "LU"
        },
        {
            "name": "Macao",
            "dial_code": "853",
            "code": "MO"
        },
        {
            "name": "Macedonia",
            "dial_code": "389",
            "code": "MK"
        },
        {
            "name": "Madagascar",
            "dial_code": "261",
            "code": "MG"
        },
        {
            "name": "Malawi",
            "dial_code": "265",
            "code": "MW"
        },
        {
            "name": "Malaysia",
            "dial_code": "60",
            "code": "MY"
        },
        {
            "name": "Maldives",
            "dial_code": "960",
            "code": "MV"
        },
        {
            "name": "Mali",
            "dial_code": "223",
            "code": "ML"
        },
        {
            "name": "Malta",
            "dial_code": "356",
            "code": "MT"
        },
        {
            "name": "Marshall Islands",
            "dial_code": "692",
            "code": "MH"
        },
        {
            "name": "Martinique",
            "dial_code": "596",
            "code": "MQ"
        },
        {
            "name": "Mauritania",
            "dial_code": "222",
            "code": "MR"
        },
        {
            "name": "Mauritius",
            "dial_code": "230",
            "code": "MU"
        },
        {
            "name": "Mayotte",
            "dial_code": "262",
            "code": "YT"
        },
        {
            "name": "Mexico",
            "dial_code": "52",
            "code": "MX"
        },
        {
            "name": "Micronesia, Federated States of Micronesia",
            "dial_code": "691",
            "code": "FM"
        },
        {
            "name": "Moldova",
            "dial_code": "373",
            "code": "MD"
        },
        {
            "name": "Monaco",
            "dial_code": "377",
            "code": "MC"
        },
        {
            "name": "Mongolia",
            "dial_code": "976",
            "code": "MN"
        },
        {
            "name": "Montenegro",
            "dial_code": "382",
            "code": "ME"
        },
        {
            "name": "Montserrat",
            "dial_code": "1664",
            "code": "MS"
        },
        {
            "name": "Morocco",
            "dial_code": "212",
            "code": "MA"
        },
        {
            "name": "Mozambique",
            "dial_code": "258",
            "code": "MZ"
        },
        {
            "name": "Myanmar",
            "dial_code": "95",
            "code": "MM"
        },
        {
            "name": "Namibia",
            "dial_code": "264",
            "code": "NA"
        },
        {
            "name": "Nauru",
            "dial_code": "674",
            "code": "NR"
        },
        {
            "name": "Nepal",
            "dial_code": "977",
            "code": "NP"
        },
        {
            "name": "Netherlands",
            "dial_code": "31",
            "code": "NL"
        },
        {
            "name": "Netherlands Antilles",
            "dial_code": "599",
            "code": "AN"
        },
        {
            "name": "New Caledonia",
            "dial_code": "687",
            "code": "NC"
        },
        {
            "name": "New Zealand",
            "dial_code": "64",
            "code": "NZ"
        },
        {
            "name": "Nicaragua",
            "dial_code": "505",
            "code": "NI"
        },
        {
            "name": "Niger",
            "dial_code": "227",
            "code": "NE"
        },
        {
            "name": "Nigeria",
            "dial_code": "234",
            "code": "NG"
        },
        {
            "name": "Niue",
            "dial_code": "683",
            "code": "NU"
        },
        {
            "name": "Norfolk Island",
            "dial_code": "672",
            "code": "NF"
        },
        {
            "name": "Northern Mariana Islands",
            "dial_code": "1670",
            "code": "MP"
        },
        {
            "name": "Norway",
            "dial_code": "47",
            "code": "NO"
        },
        {
            "name": "Oman",
            "dial_code": "968",
            "code": "OM"
        },
        {
            "name": "Pakistan",
            "dial_code": "92",
            "code": "PK"
        },
        {
            "name": "Palau",
            "dial_code": "680",
            "code": "PW"
        },
        {
            "name": "Palestinian Territory, Occupied",
            "dial_code": "970",
            "code": "PS"
        },
        {
            "name": "Panama",
            "dial_code": "507",
            "code": "PA"
        },
        {
            "name": "Papua New Guinea",
            "dial_code": "675",
            "code": "PG"
        },
        {
            "name": "Paraguay",
            "dial_code": "595",
            "code": "PY"
        },
        {
            "name": "Peru",
            "dial_code": "51",
            "code": "PE"
        },
        {
            "name": "Philippines",
            "dial_code": "63",
            "code": "PH"
        },
        {
            "name": "Pitcairn",
            "dial_code": "872",
            "code": "PN"
        },
        {
            "name": "Poland",
            "dial_code": "48",
            "code": "PL"
        },
        {
            "name": "Portugal",
            "dial_code": "351",
            "code": "PT"
        },
        {
            "name": "Puerto Rico",
            "dial_code": "1939",
            "code": "PR"
        },
        {
            "name": "Qatar",
            "dial_code": "974",
            "code": "QA"
        },
        {
            "name": "Romania",
            "dial_code": "40",
            "code": "RO"
        },
        {
            "name": "Russia",
            "dial_code": "7",
            "code": "RU"
        },
        {
            "name": "Rwanda",
            "dial_code": "250",
            "code": "RW"
        },
        {
            "name": "Reunion",
            "dial_code": "262",
            "code": "RE"
        },
        {
            "name": "Saint Barthelemy",
            "dial_code": "590",
            "code": "BL"
        },
        {
            "name": "Saint Helena, Ascension and Tristan Da Cunha",
            "dial_code": "290",
            "code": "SH"
        },
        {
            "name": "Saint Kitts and Nevis",
            "dial_code": "1869",
            "code": "KN"
        },
        {
            "name": "Saint Lucia",
            "dial_code": "1758",
            "code": "LC"
        },
        {
            "name": "Saint Martin",
            "dial_code": "590",
            "code": "MF"
        },
        {
            "name": "Saint Pierre and Miquelon",
            "dial_code": "508",
            "code": "PM"
        },
        {
            "name": "Saint Vincent and the Grenadines",
            "dial_code": "1784",
            "code": "VC"
        },
        {
            "name": "Samoa",
            "dial_code": "685",
            "code": "WS"
        },
        {
            "name": "San Marino",
            "dial_code": "378",
            "code": "SM"
        },
        {
            "name": "Sao Tome and Principe",
            "dial_code": "239",
            "code": "ST"
        },
        {
            "name": "Saudi Arabia",
            "dial_code": "966",
            "code": "SA"
        },
        {
            "name": "Senegal",
            "dial_code": "221",
            "code": "SN"
        },
        {
            "name": "Serbia",
            "dial_code": "381",
            "code": "RS"
        },
        {
            "name": "Seychelles",
            "dial_code": "248",
            "code": "SC"
        },
        {
            "name": "Sierra Leone",
            "dial_code": "232",
            "code": "SL"
        },
        {
            "name": "Singapore",
            "dial_code": "65",
            "code": "SG"
        },
        {
            "name": "Slovakia",
            "dial_code": "421",
            "code": "SK"
        },
        {
            "name": "Slovenia",
            "dial_code": "386",
            "code": "SI"
        },
        {
            "name": "Solomon Islands",
            "dial_code": "677",
            "code": "SB"
        },
        {
            "name": "Somalia",
            "dial_code": "252",
            "code": "SO"
        },
        {
            "name": "South Africa",
            "dial_code": "27",
            "code": "ZA"
        },
        {
            "name": "South Sudan",
            "dial_code": "211",
            "code": "SS"
        },
        {
            "name": "South Georgia and the South Sandwich Islands",
            "dial_code": "500",
            "code": "GS"
        },
        {
            "name": "Spain",
            "dial_code": "34",
            "code": "ES"
        },
        {
            "name": "Sri Lanka",
            "dial_code": "94",
            "code": "LK"
        },
        {
            "name": "Sudan",
            "dial_code": "249",
            "code": "SD"
        },
        {
            "name": "Suriname",
            "dial_code": "597",
            "code": "SR"
        },
        {
            "name": "Svalbard and Jan Mayen",
            "dial_code": "47",
            "code": "SJ"
        },
        {
            "name": "Swaziland",
            "dial_code": "268",
            "code": "SZ"
        },
        {
            "name": "Sweden",
            "dial_code": "46",
            "code": "SE"
        },
        {
            "name": "Switzerland",
            "dial_code": "41",
            "code": "CH"
        },
        {
            "name": "Syrian Arab Republic",
            "dial_code": "963",
            "code": "SY"
        },
        {
            "name": "Taiwan",
            "dial_code": "886",
            "code": "TW"
        },
        {
            "name": "Tajikistan",
            "dial_code": "992",
            "code": "TJ"
        },
        {
            "name": "Tanzania, United Republic of Tanzania",
            "dial_code": "255",
            "code": "TZ"
        },
        {
            "name": "Thailand",
            "dial_code": "66",
            "code": "TH"
        },
        {
            "name": "Timor-Leste",
            "dial_code": "670",
            "code": "TL"
        },
        {
            "name": "Togo",
            "dial_code": "228",
            "code": "TG"
        },
        {
            "name": "Tokelau",
            "dial_code": "690",
            "code": "TK"
        },
        {
            "name": "Tonga",
            "dial_code": "676",
            "code": "TO"
        },
        {
            "name": "Trinidad and Tobago",
            "dial_code": "1868",
            "code": "TT"
        },
        {
            "name": "Tunisia",
            "dial_code": "216",
            "code": "TN"
        },
        {
            "name": "Turkey",
            "dial_code": "90",
            "code": "TR"
        },
        {
            "name": "Turkmenistan",
            "dial_code": "993",
            "code": "TM"
        },
        {
            "name": "Turks and Caicos Islands",
            "dial_code": "1649",
            "code": "TC"
        },
        {
            "name": "Tuvalu",
            "dial_code": "688",
            "code": "TV"
        },
        {
            "name": "Uganda",
            "dial_code": "256",
            "code": "UG"
        },
        {
            "name": "Ukraine",
            "dial_code": "380",
            "code": "UA"
        },
        {
            "name": "United Arab Emirates",
            "dial_code": "971",
            "code": "AE"
        },
        {
            "name": "United Kingdom",
            "dial_code": "44",
            "code": "GB"
        },
        {
            "name": "United States",
            "dial_code": "1",
            "code": "US"
        },
        {
            "name": "Uruguay",
            "dial_code": "598",
            "code": "UY"
        },
        {
            "name": "Uzbekistan",
            "dial_code": "998",
            "code": "UZ"
        },
        {
            "name": "Vanuatu",
            "dial_code": "678",
            "code": "VU"
        },
        {
            "name": "Venezuela, Bolivarian Republic of Venezuela",
            "dial_code": "58",
            "code": "VE"
        },
        {
            "name": "Vietnam",
            "dial_code": "84",
            "code": "VN"
        },
        {
            "name": "Virgin Islands, British",
            "dial_code": "1284",
            "code": "VG"
        },
        {
            "name": "Virgin Islands, U.S.",
            "dial_code": "1340",
            "code": "VI"
        },
        {
            "name": "Wallis and Futuna",
            "dial_code": "681",
            "code": "WF"
        },
        {
            "name": "Yemen",
            "dial_code": "967",
            "code": "YE"
        },
        {
            "name": "Zambia",
            "dial_code": "260",
            "code": "ZM"
        },
        {
            "name": "Zimbabwe",
            "dial_code": "263",
            "code": "ZW"
        }
    ]

    static getStatesForCountry(countryCode: string): string[] | null {
        let states;
        if (countryCode === StaticDataService.UNITED_KINGDOM) {
            states = StaticDataService.UK_COUNTIES.map(county => county.name);
        } else if (countryCode === StaticDataService.UNITED_STATES) {
            states = StaticDataService.US_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.AUSTRALIA) {
            states = StaticDataService.AU_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.CANADA) {
            states = StaticDataService.CA_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.CHINA) {
            states = StaticDataService.CN_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.ITALY) {
            states = StaticDataService.IT_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.INDIA) {
            states = StaticDataService.IN_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.MEXICO) {
            states = StaticDataService.MX_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.BRAZIL) {
            states = StaticDataService.BR_STATES.map(state => state.name);
        } else if (countryCode === StaticDataService.IRELAND) {
            states = StaticDataService.IE_STATES.map(state => state.name);
        }

        if (states) {
            states = states.sort((a, b) => (a < b) ? -1 : (a > b) ? 1 : 0);
        }

        return states;
    }

    getCountryForCode(countryCode: string) {
        const countries = StaticDataService.COUNTRIES.filter(country => country.countryCode === countryCode);
        return countries && countries.length > 0 ? countries[0] : null; // should only ever be one matching country
    }

    static getPostcodeValidationRegex(countryCode: string): RegExp {
        if (!countryCode) {
            return;
        }
        const regexForCountry = StaticDataService.postcodeRegex.find(x => x.countryCode === countryCode);
        if (!regexForCountry) {
            return;
        }
        return new RegExp(regexForCountry.regex, 'i');
    }
}

export const GlobalPaymentAuthCodes: { code: string, isSuccess: boolean, description: string, fullDescription: string, isGeneric: boolean }[] = [
    { code: '00', isSuccess: true, description: 'Successful – The transaction has been authorized successfully; you may proceed with the sale.', fullDescription: 'Successful – The transaction has been authorized successfully; you may proceed with the sale.', isGeneric: false },
    { code: '101', isSuccess: false, description: 'Decline - insufficient funds or incorrect card data supplied, for example, expiry date or security code. Please try again and if this issue persists, contact your bank.', fullDescription: 'Decline - Generally insufficient funds or incorrect card data supplied, for example, expiry date or security code.', isGeneric: false },
    { code: '110', isSuccess: false, description: 'Blocked - the transaction was blocked. Please contact your bank.', fullDescription: 'Decline - Generally insufficient funds or incorrect card data supplied, for example, expiry date or security code.', isGeneric: false },
    { code: '102', isSuccess: false, description: 'Referral B - The card has been declined. Please contact your bank.', fullDescription: 'Referral B - Contact the Authorization Center. Usually treated as a standard decline for Ecommerce systems, the transaction can still be processed using a Manual request once an authorization code is obtained.', isGeneric: false },
    { code: '103', isSuccess: false, description: 'Referral A - The card has been reported lost or stolen.', fullDescription: 'Referral A - The card has been reported lost or stolen. Usually treated as a standard decline for ecommerce systems.', isGeneric: false },
    { code: '200', isSuccess: false, description: 'An error occurred with your banking provider. Please try again later.', fullDescription: 'Error with bank systems – generally you can tell the customer to try again later. The resolution time depends on the issue.', isGeneric: false },
    { code: '300', isSuccess: false, description: 'An internal error occurred. Please try again later.', fullDescription: 'Error with Global Payments systems – generally you can tell the customer to try again later. The resolution time depends on the issue.', isGeneric: false },
    { code: '5', isSuccess: false, description: 'An internal error occurred.', fullDescription: 'Invalid content in request message. These can be due to a formatting issue or account configuration.', isGeneric: true },
    { code: '666', isSuccess: false, description: 'An internal error occurred.', fullDescription: 'Account deactivated – your Global Payments account has been suspended. Please contact Global Payments.', isGeneric: false }
];

export function getGlobalPaymentAuthResultDescription(authResult: string, getFullDescription: boolean = false): string {
    if (!authResult)
        return 'Payment was not attempted. The user went to the checkout page, but did not proceed with payment.';
    const gpError = GlobalPaymentAuthCodes.find(x => x.code === authResult);
    if (gpError) {
        return getFullDescription ? gpError.fullDescription : gpError.description;
    }
    else {
        const gpError = GlobalPaymentAuthCodes
            .filter(x => x.isGeneric)
            .find(x => authResult.startsWith(x.code));
        if (gpError) {
            return getFullDescription ? gpError.fullDescription : gpError.description;
        }
    }
    return 'An unknown error occurred';
}